export const SEARCH_TIMEOUT_MS = 30000;
export const SEARCH_TIMEOUT_ERROR_MESSAGE = 'Search timed out after 30 seconds';
